import noop from 'lodash/noop';


export const handleErrorWithPromise =
  (handler = noop, log = true) =>
  (err) => {
    if (log) {
      console.error(err);
    }

    handler(err);

    // we should keep promise chain to be available for next .catch chains
    return new Promise((resolve, reject) => {
      reject(err);
    });
  };
